import qs from 'qs';

import { Lens } from './lens';

export const parseQueryStringLens = new Lens(
	(search: string) => qs.parse(search, { ignoreQueryPrefix: true }),
	(x) => qs.stringify(x, { addQueryPrefix: true })
);
